import Spinner from '@wolffun/shared/src/Components/Spinner';
export default Spinner;